// Control Manager services repository
import { isIterable, findInIterable } from '../utils'
import {hasOpt} from '../ControlManager/scripts/options'
import update from 'immutability-helper'

let convertToManagedArray = function(src){
  // console.log(src)
  return src.map( item => {return {value: item, label: item}})
}

let unwrp = val=>{
  let r
  if( Array.isArray(val) ) r = val[0]
  else r = val
  if( !r ) return r
  if( r.value ) r = r.value
  return r
}

let cleanTree = (tree, basicTrim)=>{

  // console.log('accepting tree', tree)
  let newTree = {}
  for(let leafName in tree){
    let leaf = tree[leafName]
    // console.log('looking at leaf', leaf)
    let unsetArr = ['source', 'idx', 'updated']
    if( !basicTrim ) unsetArr.push('label')
    let newLeaf = update(leaf, {
      $unset: unsetArr
    })
    // console.log('made new leaf', newLeaf)
    // console.log('new leaf in conman', newLeaf)
    if(!basicTrim && newLeaf.content){
       newTree[leafName] = newLeaf
       // console.log('setting leaf because have content')
    } else {
      newTree[leafName] = newLeaf
    }
  }
  // console.log('returning cleaned tree', clone(tree))
  // console.log('returning cleaned tree', newTree)
  return newTree
}

let traverseSchema = function(schema, source, tree, callback){
  //console.log('scanning')
  let scanSchemaLayer = function(sch, src, hierarchyChain = []){
    let success = false
    let scanned = false

    let genMapOpt = function(curSrc, control){
      return opt => {
        let idx = findInIterable( v => unwrp(v) === unwrp(opt), curSrc )
        if( control.children ){
          //console.log(`${control.name} added itself to hierarchy as an option`)
          hierarchyChain = [...hierarchyChain, control.name]
        }
        if( ~idx && control.children ) {
          src['$parent'] = curSrc[idx]
          //console.log(`control ${control.name} with children and no val scanning layer`)
          scanSchemaLayer(control.children, src, hierarchyChain.slice(0))
          //console.log(`control ${control.name} finished childed valueless scan`)
          scanned = true
        } else if( control.children ){
          // console.log(`control ${control.name} with children scanning layer`)
          scanSchemaLayer(control.children, src, hierarchyChain.slice(0))
          // console.log(`control ${control.name} finished childed valued scan`)
          scanned = true
        } else if( !control.children ){
          let hierIdx = hierarchyChain.indexOf(control.name)
          if( ~hierIdx ) hierarchyChain = [...hierarchyChain.slice(0, hierIdx), ...hierarchyChain.slice(hierIdx + 1)]
        }
      }
    }

    for( let controlIdx in sch ) {
      // console.log('in traverse schema', controlIdx, sch[controlIdx])
      if( controlIdx === '_changed' ) continue
      let control = sch[controlIdx]
      if( success ) return
      let source = src
      let sourceAddr = control.source
      if( !sourceAddr ) {
        if( control.children && !success ){
          //console.log(`control ${control.name} scanning, probably page`)
          scanSchemaLayer(control.children, src, hierarchyChain.slice(0))
          // console.log(`control ${control.name} done page scan`)
          continue
        }
        sourceAddr = ''
      }
      let sourceAddress = sourceAddr.split('.')
      let zone = sourceAddress[0], name = sourceAddress[1]
      // let haveSource = true
      // if( !source[zone] || !source[zone][name] ) haveSource = false
      source[zone] = source[zone] || {}
      source[zone][name] = source[zone][name] || []
      // let trueSrc = []
      let curSrc = source[zone][name]
    //  console.log("before executing genMapOpt")
      let mapOpt = genMapOpt(curSrc, control)
      // if( haveSource ){
      //   trueSrc = src[zone][name]
      // }
      let leaf = tree[control.name]
      //console.log('before callback')
      let res = callback(control, source[zone][name], hierarchyChain, tree)

      if( res ) {
        if( res.source ) {
          src[zone] = src[zone] || {}
          src[zone][name] = src[zone][name] || {}
          src[zone][name] = res.source
        }
        if( res.control ) {
          sch[controlIdx] = res.control
        }
        if( res.success ) {
          success = res.success
        }
      }
      // console.log('looking at leaf', leaf)
      if( leaf && leaf.content && !success ){
        let val = leaf.content
        if( isIterable(val) ) {
          //console.log('parsing control %s values', control.name)
          val.map(mapOpt)
        } else {
          let idx = findInIterable( v => unwrp(v) === unwrp(val), curSrc )
          if( control.children ){
            if( ~idx ){
              src['$parent'] = curSrc[idx]
            }
          }
        }
      }
      // if( control.children ){
      //   hierarchyChain = [...hierarchyChain, control.name]
      //   console.log(`${control.name} adds self to chain`, hierarchyChain)
      //
      // }
      if( !scanned && !success ) {
        // console.log(`control ${control.name} hasn't been scanned, so we scan it`)
        if( !control.children )
          scanSchemaLayer(control.children, src, hierarchyChain.slice(0))
        else
          scanSchemaLayer(control.children, src, [...hierarchyChain, control.name])
        // console.log(`control ${control.name} undone scanning complete`)

      }
      //if( ~hierIdx ) hierarchyChain = [...hierarchyChain.slice(0, hierIdx), ...hierarchyChain.slice(hierIdx + 1)]
    }
  }
  // console.log('running initial schema scan')
  scanSchemaLayer(schema, source, [])
  // console.log('inital scan done')
  return {schema, source, tree}
  // console.log('finsihed schema scan')
}


export {convertToManagedArray, unwrp, traverseSchema, cleanTree, hasOpt}
